//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {BaseService} from './base-service';
import {API_URL} from '../shared/api';
import {catchError, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiHealthService extends BaseService {
  checkHealth(): Observable<boolean> {
    const url = this.getUrl(API_URL.API_HEALTH);
    return this.http.get<null>(url).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }
}
